// 👇️ using noConflict mode
const $jq = jQuery.noConflict();

(()=>{
  let apiReadyResolve = null;
  let apiReady = null;
  function youtubeIframeAPIHelper_load() {
    if (apiReady) return apiReady;
    apiReady = new Promise(resolve => {
      apiReadyResolve = resolve;
    });

    if (window.onYouTubeIframeAPIReady) {
      // If onYouTubeIframeAPIReady is already defined, we need to call it
      const {
        onYouTubeIframeAPIReady
      } = window;

      window.onYouTubeIframeAPIReady = () => {
        onYouTubeIframeAPIReady();
        apiReadyResolve();
      };
    } else {
      window.onYouTubeIframeAPIReady = apiReadyResolve;
    }

    if (!document.querySelector('#youtube-api-script')) {
      const script = document.createElement('script');
      script.setAttribute('id', 'youtube-api-script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', 'https://www.youtube.com/iframe_api');
      document.body.appendChild(script);
    }

    if (window.YT && YT.loaded) {
      apiReadyResolve();
    }

    return apiReady;
  }


  const parentSlider = document.querySelector('.slideshow--viewport').getAttribute('id');

  const videoSlider = document.querySelectorAll('[data-video="youtube"]');

  //  load API then load Movies
  // =====================================
  window.addEventListener('load',()=>{

    youtubeIframeAPIHelper_load().then(startSlidermMvoie());

  });


  let sliderplayer;
  let done = false;


  function startSlidermMvoie(){
    videoSlider.forEach((item)=>{
      item.lastElementChild.remove();


      const player_id = 'slider-' + item.parentElement.getAttribute('data-slick-index');

      item.querySelector('.js-youtubeinner').setAttribute('id',player_id);
      const video_id = item.dataset.videoId;

      setTimeout(function(){
        sliderplayer = new YT.Player(player_id,{
          videoId: video_id,
          events: {
            'onStateChange': onPlayerStateChange
          }
        });
        item.classList.add('is-movie-loaded');
      },100);


      function onPlayerStateChange(event){
        if (event.data == YT.PlayerState.PLAYING) {
          pauseSlider();
        }
        if (event.data == YT.PlayerState.ENDED) {
          startSlider();
        }
      }

      function stopVideo() {
        sliderplayer.stopVideo();
      }

      $jq('.slideshow--viewport').on('afterChange',function(){
        stopVideo();
        $jq(this).slick('slickPlay');
      });

    });
  }

  function pauseSlider(){
    $jq('.slideshow--viewport').slick("slickPause");
  }
  function startSlider(){
    $jq('.slideshow--viewport').slick("slickPlay");
  }


  //  init Slider
  // ----------------------------------------
  $jq(function(){
    $jq(document).ready(function () {
      $jq(".slideshow--viewport").slick({
        infinite: true,
        autoplay: true,
        dots: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              arrows: false
            }
          },
        ]
      });
    });


  });
})();
